module.exports = __webpack_public_path__ + "img/pink_attached.59a6b11a.svg";